import axios from 'axios';

// 受験者のステータスを更新した後、ページ遷移を行う 
export function updateApplicantStatusAndRedirect(changeStatus: String) {
  Promise.resolve()
    .then(() =>
      axios.put('/api/applicant/status', {status: changeStatus}))
    .catch((e) => {
      // TODO: ステータスが取得できなかったときの処理
      console.log(e);
    })
    .finally(() => {
      window.location.href = '/exam/redirect_by_status';
    });
}
